import React from 'react';
import { MessageSquare, Twitter, Github, Mail } from 'lucide-react';
import { mockContacts } from '../mock';
import './Contact.css';

const Contact = () => {
  const iconMap = {
    MessageSquare: MessageSquare,
    Twitter: Twitter,
    Github: Github,
    Mail: Mail
  };

  return (
    <section id="contact" className="section contact-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Contact</h2>
          <p className="section-subtitle">Let's create something amazing together</p>
        </div>
        
        <div className="contact-content">
          <p className="contact-description">
            I'm always open to discussing new projects, creative ideas, or opportunities to be part of your visions.
            Feel free to reach out through any of these platforms.
          </p>
          
          <div className="contact-grid">
            {mockContacts.map((contact, index) => {
              const IconComponent = iconMap[contact.icon];
              const isDiscord = contact.platform === 'Discord';
              
              return (
                <div key={index} className="contact-card">
                  {isDiscord ? (
                    <div className="contact-link-disabled">
                      <div className="contact-icon">
                        <IconComponent size={24} />
                      </div>
                      <div className="contact-info">
                        <div className="contact-platform">{contact.platform}</div>
                        <div className="contact-handle">{contact.handle}</div>
                      </div>
                    </div>
                  ) : (
                    <a 
                      href={contact.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="contact-link"
                    >
                      <div className="contact-icon">
                        <IconComponent size={24} />
                      </div>
                      <div className="contact-info">
                        <div className="contact-platform">{contact.platform}</div>
                        <div className="contact-handle">{contact.handle}</div>
                      </div>
                    </a>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        
        <footer className="footer">
          <p className="footer-text">© 2025 xeerp. Built with ❤️</p>
        </footer>
      </div>
    </section>
  );
};

export default Contact;